<template>
  <div class="modal-dialog__content">
    <Headline class="modal-dialog__headline" v-if="headline" :value="headline" />
    <div v-if="response && response.type === 'string'" v-html="response.content" />
    <div v-else>{{ content }}</div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Headline from '@/components/Headline.vue'
import { API, ModalContentRequest } from '@/modules/api'

@Component({
  components: {
    Headline,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
})
export default class AjaxContent extends Vue {
  response = {}
  headline = ''
  content = ''

  created () {
    if (this.config.url) this.createApiCall()
    else this.fillModalWithStaticContent()
  }

  createApiCall () {
    new API()
      .getJsonForModal(new ModalContentRequest(this.config.url))
      .then(this.readResponseData)
  }

  readResponseData (response) {
    this.response = response
    this.headline = response.headline || this.config.modalHeadline
    this.$emit('title', response.title)
    this.$emit('subtitle', response.subtitle)
  }

  fillModalWithStaticContent () {
    this.headline = this.config.modalHeadline
    this.content = this.config.modalContent
  }
}
</script>

<style lang="scss">
.modal-dialog__content {
  font-family: 'Gotham';
  font-weight: 300;
}
.modal-dialog__headline {
  text-transform: uppercase;
  text-align: center;
  color: #005CA9;
  margin-bottom: 15px;
  flex-direction: column;

  @media screen and (min-width: 768px) {
    margin-bottom: 35px;
  }
  
  h1 {
    font-size: 36px;
    font-family: 'Gotham';
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    margin: 0;
    padding: 0;
  }

  hr {
    background-color: #005CA9;
    width: 54px;
    height: 6px;
    border: 0;
    border-radius: 0;
    margin: 2px auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/Content.vue